module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp12_7005.5c7a62bc.png";